var _path, _path2, _path3, _path4, _path5, _path6, _path7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTata(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 43,
    viewBox: "0 0 49 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.49713 42.0983V33.6014H0V30.1254H11.7866V33.6014H8.41899V42.0983H3.49713Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.8106 42.0983V33.6014H23.3135V30.1254H35.1001V33.6014H31.7325V42.0983H26.8106Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.6211 42.0983L15.0249 30.1254H20.0761L24.739 42.0983H20.0761L17.6153 34.7601L15.1543 42.0983H10.6211Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.9346 42.0983L38.3384 30.1254H43.2602L48.0525 42.0983H43.3897L40.9288 34.7601L38.4679 42.0983H33.9346Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.1327 23.3021C11.009 21.6284 5.82812 17.2512 5.82812 11.9729C5.82812 11.3292 5.95766 10.6855 6.08719 10.0418C9.58428 9.14057 18.6508 7.72441 20.3346 8.75434C21.5003 9.52679 19.2984 18.1524 18.1327 23.3021Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.8358 10.0418C41.9653 10.6855 42.0948 11.3292 42.0948 11.9729C42.0948 17.2512 36.9139 21.7572 29.7902 23.3021C28.6245 18.0237 26.4227 9.39805 27.5884 8.75434C29.2722 7.72441 38.3387 9.14057 41.8358 10.0418Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.9614 0C31.7327 0 38.4678 3.34727 40.9288 7.8532C38.0793 7.33824 24.4795 4.24845 24.7386 6.82327V23.9458C24.4795 23.9458 24.2205 23.9458 23.9614 23.9458C23.7024 23.9458 23.4434 23.9458 23.1843 23.9458V6.95201C23.3138 4.24845 9.97313 7.46698 6.99414 7.98194C9.45505 3.34727 16.1901 0 23.9614 0Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTata);
export default __webpack_public_path__ + "static/media/tata.aaceff5150511f28cd2c3bb9c676fdbb.svg";
export { ForwardRef as ReactComponent };